const DEFAULT_WHATSAPP_NUMBER = '5491165802747';

export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || DEFAULT_WHATSAPP_NUMBER;

export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
